import { SearchMarkedText } from "@ext/serach/components/results/SearchMarkedText";
import type { SearchResultMarkItem } from "@ext/serach/Searcher";

export interface SearchResultParagraphItemProps {
	text: SearchResultMarkItem[];
}

export const SearchResultParagraphItem = (props: SearchResultParagraphItemProps) => {
	const { text } = props;

	return (
		<div className="px-2.5 py-1.5 font-normal leading-4 text-xs">
			<SearchMarkedText marks={text} />
		</div>
	);
};
